<template>
  <base-layout>
    <base-dashboard :is-loading="isLoading">
      <div
        class="page-header bg-secondary m-0 p-3 border-bottom"
      >
        <h1
          class="page-title"
          v-if="campaignName!==''"
        >
          Campaign showcase - {{ campaignName }}
        </h1>
      </div>
      <div class="content-wrapper">
        <creatives-page />
      </div>
    </base-dashboard>
  </base-layout>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import * as types from '@/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';

import BaseLayout from '@/components/BaseLayout.vue';
import BaseDashboard from '@/components/BaseDashboard.vue';
import CreativesPage from '@/modules/content/components/CreativesPage/CreativesPage.vue';

export default {
  name: 'Showcase',
  components: {
    BaseDashboard,
    BaseLayout,
    CreativesPage,
  },
  data() {
    return {
      isLoading: false,
      readOnly: ['creative-properties'],
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('content', [
      'creative',
      'feedId',
      'sharedCount',
      'activeCreatives',
    ]),
    ...mapState('account', [
      'shareeCount',
    ]),
    campaignName() {
      return this.campaign?.name || '';
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.RESET_CAMPAIGN,
      campaignTypes.GET_CAMPAIGN_BY_ID,
      campaignTypes.FETCH_ORDER,
      campaignTypes.SET_VIEW_TYPE,
    ]),
    ...mapActions('content', [
      contentTypes.FETCH_EXISTING_CREATIVES_AS_SHAREE,
      contentTypes.FETCH_SHARED_COUNT,
    ]),
    ...mapMutations('content', [
      contentTypes.SET_CREATIVE,
    ]),
    ...mapMutations([
      types.SET_GLOBAL_MESSAGE,
    ]),
    async handleCreate() {
      this.isLoading = true;
      this.SET_VIEW_TYPE('Showcase');
      const { creativeKey } = this.$route.query;
      const { campaignId } = this.$route.params;
      try {
        await this.GET_CAMPAIGN_BY_ID(campaignId)
          .then((campaign) => {
            this.FETCH_ORDER({
              advertiserId: campaign.advertiserId,
              campaignId,
              setOrder: true,
            });
          });
        await this.FETCH_EXISTING_CREATIVES_AS_SHAREE([campaignId]);
        let selectedCreative;
        if (creativeKey) {
          selectedCreative = this.activeCreatives.find(((creative) => creative.creativeKey === creativeKey));
          if (!selectedCreative) {
            this.SET_GLOBAL_MESSAGE({
              message: 'Creative is no longer available for showcase',
              type: 'warning',
            });
            selectedCreative = this.activeCreatives[0];
          }
          this.SET_CREATIVE(selectedCreative);
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.RESET_CAMPAIGN();
    this.handleCreate();
  },
};
</script>
<style>
.content-wrapper {
  height: calc(100% - 65px);
}
.comment-wrapper {
  height: calc(100% - 56px)!important;
}
</style>
